/**
 * FASE 21.2 — Notes Mutation Adapter
 *
 * Uses notes-api.js (direct Supabase write, no offline outbox — notes are online-only).
 */

import { createNote } from "../../notes-api";
import { generateUUID } from "../../uuid";

/**
 * Create a pastoral note attached to an entity.
 * @param {Object} payload — validated
 * @param {Object} appScope
 */
export async function createFamilyNoteMutation(payload, appScope) {
  const now = Date.now();

  if (typeof navigator !== "undefined" && !navigator.onLine) {
    throw Object.assign(new Error("Nota no disponible sin conexión"), { code: "offline" });
  }

  const writePayload = {
    id:               generateUUID(),
    content:          payload.content,
    entity_id:        payload.entity_id,
    entity_type:      payload.entity_type,
    visibility_type:  payload.visibility_type ?? "private",
    district_id:      payload.district_id ?? appScope?.district_id ?? null,
    created_by_kevia: true,
    created_at:       new Date().toISOString(),
    updated_at:       new Date().toISOString(),
  };

  const data = await createNote(writePayload);
  return {
    ok:       true,
    entityId: data?.id ?? writePayload.id,
    summary:  `Nota agregada para ${writePayload.entity_type} (${writePayload.entity_id.slice(0, 8)}…).`,
    meta:     { latency: Date.now() - now, auditType: "pastoral_care" },
  };
}
